export default __webpack_public_path__ + "static/P_SearchThumb_IN-W2-9a1eae404b5d73c0595ae0037066c5d2.webp";